var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.0536C19.9077 17.0536 21.0488 15.9125 21.0488 14.5048C21.0488 13.0971 19.9077 11.956 18.5 11.956C17.0923 11.956 15.9512 13.0971 15.9512 14.5048C15.9512 15.9125 17.0923 17.0536 18.5 17.0536Z",
    fill: "#00803D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6562 17.0536C24.5462 17.0536 25.2676 16.3322 25.2676 15.4423C25.2676 14.5524 24.5462 13.831 23.6562 13.831C22.7663 13.831 22.0449 14.5524 22.0449 15.4423C22.0449 16.3322 22.7663 17.0536 23.6562 17.0536Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3438 17.0536C14.2337 17.0536 14.9551 16.3322 14.9551 15.4423C14.9551 14.5524 14.2337 13.831 13.3438 13.831C12.4538 13.831 11.7324 14.5524 11.7324 15.4423C11.7324 16.3322 12.4538 17.0536 13.3438 17.0536Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9313 18.5006C14.2971 17.9809 13.7226 18.0497 12.9893 18.0497C11.8924 18.0497 11 18.9368 11 20.027V23.2265C11 23.6999 11.3864 24.0849 11.8616 24.0849C13.9132 24.0849 13.666 24.122 13.666 23.9964C13.666 21.7292 13.3975 20.0666 14.9313 18.5006Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1976 18.0614C17.9167 17.9546 16.8032 18.0627 15.8429 18.8554C14.2357 20.1427 14.545 21.876 14.545 23.9964C14.545 24.5574 15.0015 25.0224 15.571 25.0224C21.755 25.0224 22.0012 25.2218 22.3679 24.4098C22.4881 24.1351 22.4552 24.2224 22.4552 21.5952C22.4552 19.5085 20.6483 18.0614 19.1976 18.0614Z",
    fill: "#00803D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0107 18.0497C23.2733 18.0497 22.702 17.9816 22.0686 18.5006C23.591 20.055 23.3339 21.6042 23.3339 23.9964C23.3339 24.1228 23.1288 24.0849 25.1076 24.0849C25.5998 24.0849 26 23.6861 26 23.196V20.027C26 18.9368 25.1076 18.0497 24.0107 18.0497Z",
    fill: "#FFC20E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.edb48f36.svg";
export { ForwardRef as ReactComponent };